import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { RuntimeBoundary } from './app/runtime-boundary';
import { registerPanelServiceWorker } from './runtime/panel-service-worker';
import './foundation/living/living.scss';
import './foundation/styles/index.scss';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('panel_v2_root_missing');

createRoot(rootElement).render(
  <StrictMode>
    <RuntimeBoundary />
  </StrictMode>,
);

// docs/decisions/2026-10-28-tpv-sin-conexion.md · the app shell that opens without a connection (production builds only).
void registerPanelServiceWorker();
